import { motion, AnimatePresence } from "framer-motion";

const ScoreBoard = ({ scoreBoard, eventType }) => {
  if (!scoreBoard) return null;

  const {
    spnnation1,
    spnnation2,
    spnballrunningstatus,
    score1,
    score2,
    activenation1,
    activenation2,
    balls,
    spnrunrate1,
    spnrunrate2,
  } = scoreBoard;

  const getBallStatusText = (status) => {
    switch (status) {
      case "o":
        return "Over End";
      case "B":
        return "Ball Running";
      case "w":
        return "Wicket";
      case "^2":
        return "";
      case "nb":
        return "No Ball";
      default:
        return status || "";
    }
  };

  const getBallColor = (ball) => {
    if (ball === "6") return "bg-purple-600 text-white";
    if (ball === "4") return "bg-blue-500 text-white";
    if (ball.toLowerCase() === "w") return "bg-red-600 text-white";
    return "bg-gray-400 text-black";
  };

  const getBallAnimation = (ball) => {
    if (ball.toLowerCase() === "w") {
      return {
        initial: { scale: 1, rotate: 0 },
        animate: { scale: [1, 1.3, 1], rotate: [-5, 5, 0] },
        transition: { type: "tween", duration: 0.5 },
      };
    }
    if (ball === "6" || ball === "4") {
      return {
        initial: { scale: 0 },
        animate: { scale: [0, 1.2, 1] },
        transition: { type: "tween", duration: 0.4 },
      };
    }
    return {
      initial: { scale: 0, opacity: 0 },
      animate: { scale: 1, opacity: 1 },
      transition: { type: "tween", duration: 0.3 },
    };
  };

  return (
    <div className="w-full h-full">
      {eventType === 4 && (
        <div
          className="w-full h-full relative text-white text-xs sm:text-sm flex flex-col"
          style={{
            background: "linear-gradient(89deg,#0c9971,#0c9971 89.28%)",
          }}
        >
          <div className="p-2 sm:p-3 flex-1 flex flex-col justify-evenly">
            {/* Teams + Score */}
            <div className="flex justify-between bg-black/50 rounded-md p-2 sm:p-3">
              <div className="flex flex-col justify-center leading-5">
                <span
                  className={`${
                    activenation1 === "1" ? "text-[#8eea29]" : "text-white"
                  } text-sm sm:text-base font-bold`}
                >
                  {spnnation1 || ""}
                </span>
                <span
                  className={`${
                    activenation2 === "1" ? "text-[#8eea29]" : "text-white"
                  } text-sm sm:text-base font-bold`}
                >
                  {spnnation2 || ""}
                </span>
              </div>
              <div className="flex flex-col text-right">
                <span
                  className={`${
                    activenation1 === "1" ? "text-[#8eea29]" : "text-white"
                  } text-sm sm:text-base font-bold`}
                >
                  {score1 || ""} {spnrunrate1 ? `CRR ${spnrunrate1}` : ""}
                </span>
                <span
                  className={`${
                    activenation2 === "1" ? "text-[#8eea29]" : "text-white"
                  } text-sm sm:text-base font-bold`}
                >
                  {score2 || ""} {spnrunrate2 ? `CRR ${spnrunrate2}` : ""}
                </span>
              </div>
            </div>

            {/* Ball Status */}
            <div className="flex justify-end px-1 sm:px-2 mt-1 font-semibold">
              <span>{getBallStatusText(spnballrunningstatus)}</span>
            </div>

            {/* Ball Summary */}
            <div className="flex items-center mt-1 sm:mt-2 overflow-x-auto space-x-1">
              <span className="text-xs sm:text-sm font-semibold whitespace-nowrap">
                Ball Summary =
              </span>
              <ul className="flex ml-2 space-x-1 sm:space-x-2">
                <AnimatePresence initial={false}>
                  {balls && balls.length > 0 ? (
                    balls.map((ball, index) => (
                      <motion.li
                        key={`ball-${index}`}
                        className={`${getBallColor(
                          ball
                        )} h-6 w-6 sm:h-8 sm:w-8 min-w-[24px] sm:min-w-[32px] rounded-full flex items-center justify-center font-bold text-xs sm:text-sm`}
                        {...getBallAnimation(ball)}
                      >
                        {ball}
                      </motion.li>
                    ))
                  ) : (
                    <span className="ml-2 text-xs sm:text-sm">
                      Score Board Not Available Before Match!
                    </span>
                  )}
                </AnimatePresence>
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScoreBoard;
